import { faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "../services/i18n";
import type { ReportDataFragment } from "../types/graphql/graphql";

type ReportItemProps = {
  report: ReportDataFragment;
};

export function ReportItem({ report }: ReportItemProps) {
  return (
    <div className="bg-white-50 rounded p-3 mb-3">
      <div className="d-flex align-items-baseline gap-2 fw-bold">
        <FontAwesomeIcon icon={faComment} />
        <span>{report.reporterName}</span>
        <small className="text-muted">{formatDate(report.createdAt)}</small>
      </div>
      <p className="mb-0">{report.comment}</p>
    </div>
  );
}
